module.exports = __webpack_public_path__ + "img/part-4-2.14a1df55.webp";